import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMediaHelperStore = defineStore('mediaHelper', () => {
  const isWebpSupportedInBrowser = ref<boolean>(true);

  function setIsWebpSupportedInBrowser (payload: boolean) {
    if (isWebpSupportedInBrowser.value !== payload) {
      isWebpSupportedInBrowser.value = payload;
    }
  }

  return {
    isWebpSupportedInBrowser,
    setIsWebpSupportedInBrowser,
  };
});
